<template>
	<v-container>
		<v-row>
			<v-col
					cols="12"
					md="9"
					lg="6"
			>
				<v-skeleton-loader
						v-if="!prepared"
				/>
				<v-card v-else>
					<v-overlay
							v-if="loading"
							absolute
					>
						<v-progress-circular indeterminate />
					</v-overlay>
					<v-card-title v-text="title" />
					<v-form
							ref="form"
							@submit.stop.prevent="submit"
					>
						<v-card-text>
							<v-row>
								<v-col
										cols="12"
										md="7"
								>
									<v-text-field
											v-model="form.title"
											label="Заголовок"
											name="title"
											:rules="[() => !!form.title || 'Заполните заголовок']"
											outlined
											dense
											hide-details
									/>
								</v-col>
								<v-col
										cols="12"
										md="5"
								>
									<v-text-field
											v-model="form.tagline"
											label="Слоган"
											name="tagline"
											:rules="[() => !!form.tagline || 'Заполните слоган']"
											outlined
											dense
											hide-details
									/>
								</v-col>
								<v-col cols="12">
									<v-textarea
											v-model="form.content"
											label="Текст"
											name="content"
											:rules="[() => !!form.content || 'Заполните текст']"
											outlined
											dense
											hint="Поддерживает markdown"
											persistent-hint
									/>
								</v-col>
								<v-col cols="12">
									<v-file-input
											v-model="form.image"
											label="Изображение"
											name="image"
											:rules="creating ? [() => !!form.image || 'Выберите изображение'] : []"
											outlined
											dense
											hide-details
									/>
								</v-col>
								<v-col
										v-if="!creating"
										cols="12"
										class="mt-0 pt-0"
								>
									<p class="pb-0 pl-10">
										<a
												:href="form.media.image.url"
												:title="form.media.image.name"
												target="_blank"
												v-text="form.media.image.name"
										/>
									</p>
								</v-col>
							</v-row>
						</v-card-text>
						<v-card-actions>
							<v-btn
									outlined
									color="green"
									type="submit"
									v-text="'Сохранить'"
							/>
							<v-btn
									outlined
									color="grey darken-2"
									@click.stop.prevent="$router.push('/stocks')"
									v-text="'Отмена'"
							/>
						</v-card-actions>
					</v-form>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	const EMPTY_FORM = () => ({
		slug: null,
		title: null,
		tagline: null,
		content: null,
		image: null,
	});

	export default {
		name: 'CreateStockModal',
		data: () => ({
			loading: false,
			prepared: false,
			form: EMPTY_FORM(),
		}),
		computed: {
			creating() {
				return this.$route.name === 'Stocks Create';
			},
			title() {
				return this.creating ? 'Создание акции' : 'Редактирование акции';
			},
			url() {
				return this.creating ? '/api/v1/stocks' : `/api/v1/stocks/${this.form.slug}`;
			},
		},
		mounted() {
			if (!this.creating) {
				this.form.slug = this.$route.params.slug;
				this.$http.get(`/api/v1/stocks/${this.form.slug}`)
				.then(response => {
					this.form = {
						...this.form,
						...response.data.data,
					}
				})
			}

			this.prepared = true;
		},
		methods: {
			reset() {
				this.form = EMPTY_FORM();
				this.$refs.form.resetValidation()
			},
			submit() {
				if (!this.$refs.form.validate() || this.loading) {
					return;
				}
				this.loading = true;
				const config = {
					params: {},
				};
				if (!this.creating) {
					config.params['_method'] = 'PUT';
				}
				this.$http.post(this.url, new FormData(this.$refs.form.$el), config)
					.then(response => {
						this.$notify(this.creating ? 'Акция создана' : 'Акция изменена');
						this.$router.push('/stocks');
					})
					.finally(() => (this.loading = false));
			},
		},
	};
</script>

<style scoped>

</style>
